// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__21bwG","content":"styles_content__3YNNc","selectAll":"styles_selectAll__2T1wJ"};